/* @flow */

import * as React from 'react'

import {
  ControlLabel,
  FormInput,
  FormGroup,
  FilesInput,
  FilesExistingValue,
  SelectInput,
  unwrapTemporaryFile,
} from '../../../../../infrastructure/components/Formik'

import DropSelector from '../../../../orders/components/DropSelector'
import SubbrandSelector from '../../../../subbrands/SubbrandSelector'
import { WebshopBannerBaseSettingsForm } from '../WebshopBanner/WebshopBannerSettings'
import { SettingsSeparator } from '../shared'

import { HelpIndicator } from '../../../../shared'

const WebshopDropLinkSettings = ({ values }) => {
  return (
    <div>
      <FormGroup>
        <ControlLabel>Drop</ControlLabel>
        <SelectInput
          name="data.drop_id"
          simpleValue
          selectComponent={DropSelector}
        />
      </FormGroup>
      <FormGroup>
        <ControlLabel>Subbrand</ControlLabel>
        <SelectInput
          name="data.subbrand_id"
          simpleValue
          selectComponent={SubbrandSelector}
        />
      </FormGroup>
      <FormGroup>
        <ControlLabel>
          Drop filter code
          <HelpIndicator id="drop-filter-code">
            Use drop filter code instead of "Drop" if you want your customers to
            buy a group of drops instead of a specific drop. All drops with the
            chosen filter code will be available
          </HelpIndicator>
        </ControlLabel>
        <FormInput name="data.drop_filter_code" />
      </FormGroup>
      <SettingsSeparator />
      <WebshopBannerBaseSettingsForm values={values} />
    </div>
  )
}

export default WebshopDropLinkSettings
